import { type ImageConfigurationOptionInput } from '../../__generated__/graphql-client-types';
import { type PermissionOption } from '../../types/project.types';

export const GRAB_BAR_DIV_SPACING = '2.25rem';

export const BACK_TO_TOP_VISIBILITY_THRESHOLD = 700;

export const COLLAPSED_GROUPS_STORAGE_KEY_PREFIX = 'collapsed-groups';

export const DefaultImageConfigOptions: ImageConfigurationOptionInput[] = [
	{
		propertyType: 'X',
		value: '0'
	},
	{
		propertyType: 'Y',
		value: '0'
	},
	{
		propertyType: 'Rotate',
		value: '0'
	}
];

export const PopoverPermissions: PermissionOption[] = [
	{ key: 'invite', label: 'Collaborator', description: 'View Discounts, Edit, Comment, and Share' },
	{ key: 'editProject', label: 'Editor', description: 'Edit, Comment, and Share' },
	{ key: 'commenting', label: 'Commenter', description: 'View and Comment' },
	{ key: 'showDiscount', label: 'Viewer', description: 'View Only' },
	{ key: 'remove', label: 'Remove', description: '' }
];

export const COVER_IMAGE_CATEGORIES = ['General', 'Kitchen', 'Bathroom', 'Laundry Room', 'Bedroom'];
